module.exports = __webpack_public_path__ + "media/images/doctor_profiles/default/ng-image__4-ed6e087bea3fe33c1b8fef0ebc402d6e.png";